const removeApolloTypeName = (obj: any) => {
  if(!obj?.__typename) return obj;
  const {__typename, ...filtered} = obj;
  return filtered;
}

export { removeApolloTypeName };
